import {
  ADD_MESSAGE,
  CHANGE_CHANNEL,
  CLEAR_PUBLIC_MESSAGES,
  DELETE_MESSAGE,
  EDIT_MESSAGE,
  EDIT_USER,
  ERROR,
  INITIAL_LOAD,
  LOAD_MORE,
  LOADING,
  MARK_AS_QUESTION,
  RESET,
  UNMARK_ALL_AS_QUESTIONS,
  UNMARK_AS_QUESTION
} from '../constants/actions/messageListActions'
import { MEMBERS } from '../constants/chatRooms'

export const initialState = {
  error: false,
  loading: true,
  messages: [],
  lastPost: null,
  hasMore: false,
  channel: MEMBERS
}

const handleSetMessages = (state, payload, initialLoad) => {
  if (payload.length === 0) {
    return {
      ...state,
      error: false,
      loading: false,
      hasMore: false
    }
  } else {
    return {
      ...state,
      error: false,
      loading: false,
      lastPost:
        payload[payload.length - 1].postdate || // public + trades
        payload[payload.length - 1].postDate, // private
      messages: initialLoad ? [...payload] : [...state.messages, ...payload],
      hasMore: payload.length > 0
    }
  }
}

export function messageListReducer(state, action) {
  switch (action.type) {
    case RESET:
      return initialState

    case ERROR:
      return {
        ...state,
        error: action.payload
      }

    case LOADING:
      return {
        ...state,
        loading: action.payload
      }

    case CHANGE_CHANNEL:
      return { ...initialState, channel: action.payload }

    case INITIAL_LOAD:
      return handleSetMessages(state, action.payload, true)

    case LOAD_MORE:
      return handleSetMessages(state, action.payload, false)

    case ADD_MESSAGE:
      return {
        ...state,
        messages: [action.payload, ...state.messages]
      }

    case DELETE_MESSAGE:
      return {
        ...state,
        messages: [
          ...state.messages.filter((mes) => mes._id !== action.payload._id)
        ]
      }

    case EDIT_MESSAGE:
      return {
        ...state,
        messages: state.messages.some((mes) => mes._id === action.payload._id)
          ? state.messages.map((mes) =>
              mes._id === action.payload._id ? action.payload : mes
            )
          : action.payload.toEveryone // when a message is turned from private to to everyone, we need to inject it into the feed
            ? [action.payload, ...state.messages]
            : state.messages
      }

    case CLEAR_PUBLIC_MESSAGES:
      return {
        ...state,
        hasMore: false,
        messages: []
      }

    case EDIT_USER:
      return {
        ...state,
        messages: state.messages.map((mes) => {
          return mes.user._id === action.payload._id
            ? {
                ...mes,
                user: action.payload
              }
            : mes
        })
      }

    case MARK_AS_QUESTION:
      return {
        ...state,
        messages: state.messages.some((mes) => mes._id === action.payload._id)
          ? state.messages.map((mes) =>
              mes._id === action.payload._id
                ? { ...mes, questionRank: action.payload.questionRank }
                : mes
            )
          : state.messages
      }

    case UNMARK_AS_QUESTION:
      return {
        ...state,
        messages: state.messages.some((mes) => mes._id === action.payload._id)
          ? state.messages.map((mes) =>
              mes._id === action.payload._id
                ? { ...mes, questionRank: null }
                : mes
            )
          : state.messages
      }

    case UNMARK_ALL_AS_QUESTIONS:
      return {
        ...state,
        messages: state.messages.map((message) => ({
          ...message,
          questionRank: null
        }))
      }

    default:
      return state
  }
}
